module.exports = __webpack_public_path__ + "img/jenkinsr.8e42f25f.jpg";